import { Control, FieldValues, Path, useController } from 'react-hook-form';
import Select from './Select/Select';
import { ISelectOption } from '../../types/ISelectOption';

type FormSelectProps<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  options: ISelectOption[];
  placeholder?: string;
  disabled?: boolean;
};

export function FormSelect<T extends FieldValues>({
  name,
  control,
  options,
  placeholder,
  disabled,
}: FormSelectProps<T>) {
  const { field, fieldState } = useController({ name, control });

  return (
    <Select
      options={options}
      value={field.value ?? null}
      onChange={(val) => field.onChange(val)}
      placeholder={placeholder}
      disabled={disabled}
      error={fieldState.error?.message ?? null}
    />
  );
}
